import { useFlowStore } from '@/state/stores/use-flow-store';
import { resolveLiveBindingFlowId } from '@/helpers/object.id.helper';
import { getEntityRefFromFlow } from '@/helpers/entity-ref.helper';
import { useFeatureAccess } from '@/hooks/use-feature-access';
import { useLiveContextCueState } from '@/hooks/use-live-context-cue-state';
import { useFlowControlLiveState } from '../flow-control-live-state';
import { useSearchParams } from 'react-router';

/** Shared live auto-cue context for Control-tab segment hooks (query + merged cue state). */
export function useFlowControlSegmentLiveContext() {
  const flow = useFlowStore((s) => s.flow);
  const [searchParams] = useSearchParams();
  const eventSlotIdParam = searchParams.get('eventSlotId');
  const { hasAccess: hasAutoCue } = useFeatureAccess('perform_auto_cue');
  const bindingFlowId = flow ? resolveLiveBindingFlowId(flow, eventSlotIdParam ?? undefined) : undefined;
  const entityRef = bindingFlowId ? getEntityRefFromFlow(bindingFlowId, flow?.liveContext) : undefined;
  const liveRunning = flow?.liveContext?.isRunning ?? false;

  const cueState = useLiveContextCueState(entityRef);
  const { liveContextState } = useFlowControlLiveState();

  return {
    hasAutoCue,
    liveRunning,
    isSimulation: !liveRunning,
    cueState,
    skippedItemIds: liveContextState?.stagedSelection?.skippedItemIds,
  };
}
